
import { Vue, Options } from "vue-class-component";
import { Ref } from "vue-property-decorator";
import { SystemApi, GetEmailTemplate } from "../../autogen";
import Page from "../molecules/Page.vue";
import ActionButton from "../atoms/ActionButton.vue";
import Table from "../molecules/Table.vue";
import UIkit from "uikit";
import EmailTemplateForm from "../organisms/EmailTemplateForm.vue";
import SearchField from "../atoms/SearchField.vue";

@Options({
  components: {
    Page,
    ActionButton,
    Table,
    SearchField,
    EmailTemplateForm
  }
})
export default class MailTemplates extends Vue {
  mailTemplates: GetEmailTemplate[] = [];
  mailTemplate: GetEmailTemplate | null = null;
  @Ref("email-template") templateFormModal!: HTMLElement;
  emailTemplateFormKey = 0;
  header = [
    { title: "テンプレート名", sortable: true, key: "name", width: "expand" },
    {
      title: "テンプレート本文(一部抜粋)",
      sortable: true,
      key: "mesagePart",
      width: "expand"
    },
    { title: "編集", type: "button", key: "edit", width: 150 }
  ];
  filterColumns = ["name", "mesage"];
  query = "";
  renewKey = 0;

  private async loadData() {
    const templatesResponse = await new SystemApi().getEmailTemplates({
      q: this.query
    });
    this.mailTemplates = templatesResponse.data.map(r =>
      Object.assign(r, {
        mesagePart: r.message.slice(0, 100).replace(/\r?\n/g, " ")
      })
    );
    this.renewKey = Date.now();
  }
  async beforeMount() {
    this.loadData();
  }
  onAddMailTemplateButtonClick() {
    this.emailTemplateFormKey = Date.now();
    this.mailTemplate = null;
    UIkit.modal(this.templateFormModal).show();
  }
  onEmailTemplateSubmitted() {
    this.loadData();
    UIkit.modal(this.templateFormModal).hide();
  }
  async onSubmitted() {
    UIkit.modal(this.templateFormModal).hide();
    await this.loadData();
  }
  async onSearch(searchResult: [] | null) {
    if (searchResult) {
      this.mailTemplates = searchResult;
    } else {
      await this.loadData();
    }
  }
  onColumnClick(location: { row: number; col: string }) {
    if (location.col === "edit") {
      this.mailTemplate = this.mailTemplates[location.row];
      this.emailTemplateFormKey = Date.now();
      UIkit.modal(this.templateFormModal).show();
    }
  }
}
